@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-card-ad/lib/index';
@import '~@adv-mt/mt-layout-basic/lib/index';
@import '~@adv-mt/mt-layout-page-content/lib/index';
@import '~@adv-mt/mt-layout-render-media-query/lib/index';
@import '~@adv-mt/mt-modal-basic-content/lib/index';
@import '~@adv-mt/mt-svg-icons/lib/index';
@import '~@adv-mt/mt-title-basic/lib/index';
@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-atom-icon/lib/index';
@import '~@s-ui/react-atom-image/lib/index';
@import '~@s-ui/react-molecule-accordion/lib/index';
@import '~@s-ui/react-molecule-modal/lib/index';

$c-card-ad-attr-item: $c-gray-dark-1 !default;
$h-modal-basic-content-header-image: 180px;
$lh-card-ad-attr-item: 16px !default;
$m-mt-reservation-payment-card-ad-wrapper: -$p-m;
$maw-mt-reservation-payment-main-content: 390px;

.mt-ReservationRefund {
  &-cardAd--borderLess {
    border-radius: 0;
  }

  &-cardAdWrapper {
    margin: $m-mt-reservation-payment-card-ad-wrapper;
  }

  &-errorText {
    color: $c-error;
    font-size: $fz-s;
  }

  &-mainContent {
    display: flex;
    flex-direction: column;
    font-size: $fz-l;
    gap: $g-xl;
    height: 48vh;

    @include media-breakpoint-up(m) {
      max-width: $maw-mt-reservation-payment-main-content;
    }
  }

  &-modalReject {
    &ContentHeaderImage {
      height: $h-modal-basic-content-header-image;
      margin-bottom: $m-xl;
    }
  }

  &-helpText {
    background-color: $c-info-light;
    border-radius: $bdrs-l;
    display: flex;
    font-size: $fz-m;
    gap: $g-m;
    padding: $p-l;
  }

  &-description {
    display: flex;
    font-size: $fz-l;
    gap: $m-m;

    &InfoDateValid {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      gap: $g-m;

      &-item {
        display: flex;
        justify-content: space-between;
      }

      &-disclamer {
        font-size: $fz-m;
        color: $c-on-surface-dim1;
      }

      &-cost {
        display: flex;
        justify-content: space-between;

        &Amount {
          font-size: $fz-xxl;
        }

        &Text {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

// TODO: Remove this override --> https://jira.ets.mpi-internal.com/browse/MTR-95001
.mt-LayoutPageContent {
  margin-top: $m-xl;
  padding: 0 $p-l;

  @include media-breakpoint-up(s) {
    margin-top: $m-xl;
    padding: 0;
  }

  &-buttonContainer {
    background-color: $c-surface;
    bottom: 0;
    justify-content: flex-start;
    padding: $p-m 0;
    position: sticky;
    z-index: 1;

    @include media-breakpoint-up(s) {
      background-color: unset;
      padding: 0;
      position: static;
    }
  }

  &-main {
    @include media-breakpoint-up(s) {
      padding: $p-xl;
    }
  }
}
